import { createSlice } from '@reduxjs/toolkit';
import { SLICES } from '../../constants/slices';
import { SESSION_STORAGE_KEYS } from '../../constants/sessionStorageKeys';

const fallbackState = {
  renewalSummary: null,
  adjustedSummary: {}
};

const initialState = (() => {
  try {
    const savedState = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.RENEWAL_HUB) || 'null');
    if (!savedState) {
      return fallbackState;
    }

    return {
      renewalSummary: savedState.renewalSummary || null,
      adjustedSummary: savedState.adjustedSummary || {}
    };
  } catch {
    return fallbackState;
  }
})();

const persistRenewalHubState = (state) => {
  try {
    sessionStorage?.setItem(
      SESSION_STORAGE_KEYS.RENEWAL_HUB,
      JSON.stringify({
        renewalSummary: state.renewalSummary,
        adjustedSummary: state.adjustedSummary
      })
    );
  } catch {
    // Ignore storage write errors (e.g. private mode/quota exceeded)
  }
};

const renewalHubSlice = createSlice({
  name: SLICES.RENEWAL_HUB,
  initialState,
  reducers: {
    setRenewalSummary: (state, action) => {
      state.renewalSummary = action.payload;
      persistRenewalHubState(state);
    },
    clearRenewalSummary: (state) => {
      state.renewalSummary = null;
      persistRenewalHubState(state);
    },
    setAdjustedSummary: (state, action) => {
      state.adjustedSummary = action.payload;
      persistRenewalHubState(state);
    },
    clearAdjustedSummary: (state) => {
      state.adjustedSummary = {};
      persistRenewalHubState(state);
    }
  }
});

export const { setRenewalSummary, clearRenewalSummary, setAdjustedSummary, clearAdjustedSummary } =
  renewalHubSlice.actions;
export default renewalHubSlice.reducer;
